import { ethers } from 'ethers';
import contractAbi from '../abis/buy-token.json';
const testnetConfigNetwork = {
  rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/'
};
export const defaultProvider = () => {
  var provider = new ethers.JsonRpcProvider('https://bsc-dataseed3.binance.org');
  if (process.env.REACT_APP_NETWORK_ID == 97) {
    provider = new ethers.JsonRpcProvider(testnetConfigNetwork.rpcUrl);
  }
  return provider;
};
export const getContractABIBuy = ()=>{
  return contractAbi;
}
export const getContractBuyAddress = ()=>{
  return process.env.REACT_APP_CONTRACT_BUY;
}
export const getBuyTokenContract = (signer = null) => {
  const contractAddress = process.env.REACT_APP_CONTRACT_BUY;
  var contract = new ethers.Contract(contractAddress, contractAbi);
  if (signer) {
    contract = new ethers.Contract(contractAddress, contractAbi, signer);
  }
  return contract;
};
